<template>    
    <div v-if="$store.state.loadingStatus"
        class="full-screen-bg" id="full-screen-loading">
        <div class="spinner-border text-dark me-2 mb-2" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="w-30" v-if="$store.state.progress >= 0">
            <div class="progress mb-3">
                <div class="progress-bar progress-bar-striped progress-bar-animated" 
                    role="progressbar" :style="{width: `${$store.state.progress}%`}" 
                    :aria-valuenow="$store.state.progress" 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                >{{ $store.state.progress }}%</div>
            </div>
        </div>
    </div>    
</template>
<script>
export default {
name:'fullScreenLoadingView',
data(){
    return {
        
    }
},
components: {
    
},
watch:{
    '$store.state.loadingStatus'(newVal) {
        if (newVal === false) {
            this.$store.state.progress = -1;
        }
    }

},
methods: {
   
},
async mounted(){
    
    
},
async created(){
    
}
};
</script>
<style scoped>

</style>